import React from "react";
import smoothscroll from "smoothscroll-polyfill";
import Provider from "~/store";
import "~/styles/index.scss";
import "mapbox-gl/dist/mapbox-gl.css";

smoothscroll.polyfill();

export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>;
